<template>
  <div id="app">
    <router-view />
    <div
      v-if="appNotUpdated"
      class="message-fixed bg-success text-white"
    >
      <p class="px-2 text-small mb-0">
        Silahkan refresh aplikasi untuk versi terbaru. Jika pesan ini masih muncul, lakukan <i>hard refresh</i> dengan menekan
        <code>CTRL + F5</code>.
      </p>
    </div>
  </div>
</template>

<style scoped>
	.message-fixed {
		position: fixed;
		width: 100%;
		padding: 10px 0;
		z-index: 9999;
		bottom: 0;
		background: white;
	}
</style>

<script>

export default {
	name: 'App',
	data(){
		return {
			appNotUpdated: false,
		}
	},
	created(){
		let webFrontEndVersion = this.$store.getters.getAppVersion
		let apiVersion = ''
		this.$store.dispatch('fetchAppVersion').then(res => {
			if(res.data.status){
				apiVersion = res.data.version
				if(webFrontEndVersion != apiVersion){
					this.appNotUpdated = true
				} else {
					this.appNotUpdated = false
				}
			}
		})
		.catch(err => {
			this.$router.push({path: '/500'})
		})

		if(!sessionStorage.auth){
			localStorage.removeItem('authService')
			localStorage.removeItem('fcmToken')
		}
	}
}
</script>
<style>
	@import url('./assets/stisla/css/style.css');
	@import url('./assets/stisla/css/components.css');
	html {
		scroll-behavior: smooth;
	}
	body{
		background-color: #ECEFF1 !important;
		overflow-x: hidden;
	}

	body.fade-in {
		animation: fadeIn .5s;
	}
	@keyframes fadeIn{0%{opacity:1}50%{opacity:.5}100%{opacity:1}}

	.hide-md {
		display: block;
	}
	
	.card-span {
			border-radius: 3px;
			box-shadow: 0 4px 8px rgb(0 0 0 / 3%);
			padding: 10px 20px 10px 10px;
			display: inline-block;
			background:white;
			font-weight: 700;
	}
	.card-span img {
			width: 30px;
			margin-right: 10px;
	}

	
	.section .section-header{
		position: fixed;
		width: calc(100% - 250px);
		z-index: 9;
		top:75px;
		
		margin-left: -32px;
		margin-right: -30px;
		padding-left: 35px;
		padding-right: 35px;
		border-radius: 0;
	}
	.section .section-body {
		padding-top: 100px;
	}
	@media (max-width: 1024px) {
		.section .section-header{
			position: fixed;
			width: 100%;
		}
		body.search-show:before, body.sidebar-show:before {
			z-index: 9;
		}
	}

	



	
	.card-item.card {
			border:1px solid #e3eaef;
			cursor: pointer;
	}
	.card-item.card.active, .card-item.card:hover {
			border:1px solid #007bff
	}
	.card-icon img {
			width:50px;
			height: 50px;
			background: #007bff;
			border-radius: 50%
	}
	.card-item-bg-img {
		width: 100%;
		height: 150px;
		background: #ddd;
		text-align: right;
		background-size:cover;
		border-bottom:1px solid #ddd
	}
	.text-job-head {
		font-size: 12px;
		font-weight: bold;
	}
	.nav.nav-pills.hover .nav-link:hover{
		box-shadow: 0 2px 6px #acb5f6;
		color: #fff;
		background-color: #6777ef;
	}
	.nav.white-space-no-wrap {
		white-space: nowrap;
		flex-wrap:nowrap;
	}

	
	.nav-pills-sm {
		font-size: .8rem;
	}
	.nav-pills-sm .nav-link {
		padding:5px 25px;
		border-radius: 20px;
		margin: 0 5px;
		background:white
	}
	.nav-pills-sm .nav-link.disabled {
		border: 1px solid transparent;
		background: transparent;
	}

	
		.paket-content {
				height: 350px;
		}
		.paket-icon img, .paket-icon div{
				width:100px;
				height: 100px;
				margin: 0 auto;
				/* background: #007bff; */
				border-radius: 50%;
		}
		.paket-icon div {
			background: #ddd;
			line-height: 100px;
		}
		.paket-item.card {
				cursor: pointer;
				border:1px solid #e3eaef;
		}
		.paket-item.card.active, .paket-item.card:hover {
				border:1px solid #007bff
		}
		/* diluar .paket */
		.paket-action {
			position: absolute;
			bottom: 50px;
			right: 40px;
		}

		.permohonan-item.card {
				border:1px solid #e3eaef;
				cursor:pointer;
		}
		.permohonan-item.card.active, .permohonan-item.card:hover {
				border:1px solid #007bff
		}
		.permohonan-icon img, .permohonan-icon div {
				width:50px;
				height: 50px;
				background: #007bff;
				border-radius: 50%
		}
		.permohonan-icon div {
			background: #eee;
		}

		.layanan-item.card {
			border:1px solid #e3eaef;
			cursor:pointer;
		}
		.layanan-item.card.active, .layanan-item.card:hover {
				border:1px solid #007bff
		}
		.layanan-item.no-hover.card:hover{
			border:1px solid #e3eaef;
			cursor: unset;
		}
		.layanan-icon img, .layanan-icon div {
				width:50px;
				height: 50px;
				/* background: #007bff; */
				border-radius: 50%
		}
		@media(max-width: 768px) {
				
		}




		input[type="text"].form-plain {
			background: transparent;
			border:none;
			border-bottom:1px solid #ddd;
		}










	.vs__dropdown-toggle {
		padding:8px;
		border-color: #e4e6fc;
		background: white;
	}



	
		.overlay-table-loader, .overlay-page-loader {
				width: 100%;
				text-align: center;
				position: absolute;
				top: 0;
				padding-top: 100px;
				padding-bottom: 100px;
				background: rgba(255,255,255, 0.5);
				height: 110vh;
		}
		.overlay-page-loader {
				z-index: 9999;
				height: 100vh;
				padding-top:30vh;
				position: fixed;
		}
		.spinner-container {
			width: 100%;
		}
		.spinner-container .spinner,
		.overlay-page-loader .spinner,
		.overlay-table-loader .spinner {
			position: relative;
			width: 50px;
			height: 50px;
			margin: 0 auto;
			background-image: url('~@/assets/img/spinner-primary.svg');
			background-size: 50px;
			background-position: center;
			background-repeat: no-repeat;
		}



		.list-group-item-action:hover {
			cursor: pointer;
		}


		.text-label {
			font-weight: 600;
			color: #34395e;
			font-size: 12px;
			letter-spacing: .5px;
		}



	.content-loader{
		/*background: #eee;
		background-image: linear-gradient(to bottom right, red, yellow);*/
		/*background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);*/
		background: linear-gradient(-45deg, #eee, #ddd, #eee);
		background-size: 400% 400%;
		color: transparent;
		border-radius: 30px;
		padding: 0 10px;
		animation: contentLoader 1s infinite;
	}




		.v-select .vs__selected-options {
			flex-wrap: nowrap;
			max-width: calc(100% - 25px);
			/* overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap; */
		}
		.v-select .vs__selected {
			display: block;
			white-space: nowrap;
			text-overflow: ellipsis;
			max-width: 100%;
			overflow: hidden;
		}


	
		.font-weight-500 {
				font-weight: 500 !important;
		}
.long-shadow {
				box-shadow: 0 0 60px rgb(103 119 239 / 15%);
		}
		
		.p-45 {
				padding: 35px !important;
		}



	@keyframes contentLoader{
		0% {
			background-position: 0% 50%;
			/*background-image: linear-gradient(to bottom right, red, yellow);*/
		}
		50% {
			background-position: 100% 50%;
		}
		100% {
			background-position: 0% 50%;
			/*background-image: linear-gradient(to bottom right, yellow, red);*/
		}
	}
	@media(max-width: 768px) {
		.hide-md{
			display:none;
		}
		.md-mr-0 {
			margin-right: 0px !important;
		}
	}
	@media (max-width: 1024px){
		.navbar .form-inline .search-element {
				position: absolute;
				top: 10px;
				left: 10px;
				right: 10px;
				z-index: 892;
				display: none;
		}
		body.search-show .navbar .form-inline .search-element {
				display: block;
		}
		.navbar .form-inline .search-element .form-control {
			width: calc(100% - 9px) !important;
			border-radius: 3px;
		}
	}


	.bg-warning-100 {
		background: #FFECB3;
	}
	.bg-success-100 {
		background: #DCEDC8;
	}
	/* #app {
		background: #eee;
	}
	.list-style-none {
		list-style: none;
	}
	.bg-light-gray {
		background:#eee!important;
	} */
</style>
